/**
 * Checks if an element has an accessible name.
 * @param element The HTML element to check.
 * @param componentName The name of the component to display in the console warning.
 */
export const checkForAccessibleName = (element: HTMLElement, componentName: string): void => {
  if (element.getAttribute('aria-label')) {
    return;
  }

  const ariaLabelledBy = element.getAttribute('aria-labelledby');
  if (ariaLabelledBy && document.getElementById(ariaLabelledBy)) {
    return;
  }

  // If no a11y check above has passed, display a console warning for developers.
  const msg = `[${componentName}]: Element does not have an accessible name! Add either an aria-label or aria-labelledby attribute to make this warning disappear.`;
  console.warn(msg, element);
};
